import React, { KeyboardEvent, MouseEvent } from "react";
import styles from "./icon-button.module.scss";
import {
  ToolTip,
  ToolTipPositionType,
} from "@components/atoms/tooltip/tooltip";
import { useI18N } from "@src/language/language-context";

interface IconButtonPropTypes {
  fun: (e: MouseEvent | KeyboardEvent) => void;
  icon: string;
  rotate?: boolean;
  disabled?: boolean;
  tooltip?: string;
  tooltipPosition?: ToolTipPositionType;
  variant?: string | string[];
  draggable?: boolean;
}

export const IconButton = ({
  fun,
  icon,
  rotate,
  disabled = false,
  tooltip = "",
  tooltipPosition = "top",
  variant,
  draggable = false,
}: IconButtonPropTypes) => {
  const i18n = useI18N();
  const texts = {
    iconButtonAltText: i18n("modules.iconButton.iconButtonAltText"),
  };
  let variantClass = "";

  if (typeof variant === "string" && variant !== "") {
    variantClass = styles[`icon-button--${variant}`];
  } else if (Array.isArray(variant)) {
    variantClass = variant.map((v) => styles[`icon-button--${v}`]).join(" ");
  }

  const handleRotate = () => {
    if (rotate !== undefined && rotate === false) {
      return styles["icon-button--rotate-back"];
    } else if (rotate !== undefined && rotate === true) {
      return styles["icon-button--rotate"];
    } else {
      return "";
    }
  };

  const button = (
    <button
      disabled={disabled}
      onClick={fun}
      className={`
        ${styles["icon-button"]}
        ${variantClass}
        ${handleRotate()}
        ${disabled ? styles["icon-button--disabled"] : ""}
      `}
      draggable={draggable}
    >
      <img
        className={disabled ? styles["icon-button__icon-disabled"] : ""}
        src={icon}
        alt={texts.iconButtonAltText}
        draggable={draggable}
      />
    </button>
  );

  return tooltip ? (
    <ToolTip content={tooltip} position={tooltipPosition}>
      {button}
    </ToolTip>
  ) : (
    button
  );
};
